import { z } from "zod";

export const feedbackSubmissionSchema = z.object({
  category: z.enum(["bug", "feature", "question", "other"]),
  subject: z.string().min(3).max(200),
  description: z.string().min(10).max(5000),
});

export type FeedbackSubmission = z.infer<typeof feedbackSubmissionSchema>;
